import React, {useState} from "react";
import {Card} from "react-bootstrap";
import {PiCaretDown, PiCaretUp, PiInfo} from "react-icons/pi";

const STORAGE_PREFIX = "cosmos-purpose-box-open-";

/** Liest den gemerkten Aufklappzustand - Zugriff defensiv, falls localStorage gesperrt ist (privater Modus u. Ä.). */
function readStoredOpen(key) {
    try {
        return window.localStorage.getItem(key) === "1";
    } catch (e) {
        return false;
    }
}

function writeStoredOpen(key, open) {
    try {
        window.localStorage.setItem(key, open ? "1" : "0");
    } catch (e) {
        // localStorage nicht verfügbar - der Aufklappzustand bleibt dann nur
        // für die laufende Sitzung erhalten, kein Fehlerfall.
    }
}

/**
 * Zweckkasten am Kopf jeder Seite des Bereichs "Cosmos"
 * (docs/tasks/2026-09-18-cosmos-bereich/KONVENTIONEN.md Abschnitt 4/5):
 * erklärt in wenigen Sätzen, was der Bildschirm zeigt. Der Text kommt je
 * Seite aus PLAN.md Abschnitt 5 und wird als Kindelement übergeben.
 * Vorbild: Components/SalesAnalysis/PurposeBox.jsx - hier je Seite ein
 * eigener Aufklappzustand über "storageKey", weil der Bereich mehrere
 * inhaltlich unterschiedliche Seiten hat statt einer gemeinsamen.
 */
export default function PurposeBox({storageKey, title = "Wozu diese Seite", children}) {
    const key = STORAGE_PREFIX + storageKey;
    const [open, setOpen] = useState(() => readStoredOpen(key));

    const toggle = () => {
        setOpen((current) => {
            const next = !current;
            writeStoredOpen(key, next);
            return next;
        });
    };

    return (
        <Card className="mb-3 border-0 bg-body-secondary">
            <button
                type="button"
                className="btn btn-link text-decoration-none text-body d-flex align-items-center gap-2 w-100 text-start px-3 py-2"
                aria-expanded={open}
                onClick={toggle}
            >
                <PiInfo className="flex-shrink-0" aria-hidden="true" />
                <span className="fw-semibold small">{title}</span>
                <span className="ms-auto">
                    {open ? <PiCaretUp aria-hidden="true" /> : <PiCaretDown aria-hidden="true" />}
                </span>
            </button>
            {open && <Card.Body className="pt-0 small text-muted">{children}</Card.Body>}
        </Card>
    );
}
